// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-browse-search-top{border-top:1px solid #d3d3d3}.widget-browse-flows>.taxon-container{overflow-x:hidden;padding:1rem;width:100%}.widget-browse-flows-padding>*{padding:0 1rem}.widget-browse-breadcrumbs{border-bottom:1px solid #d3d3d3;min-height:-moz-fit-content;min-height:fit-content}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
